// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.main_select_container__-KtmE {
    width: 100%;
    display: flex;
    background-color: #ECF0F8;
    padding: 29px;
    border-radius: 15px;
    font-family: Mulish, sans-serif;
    justify-content: space-between;
    margin-bottom: 20px;
}

.main_select_section__hBRld {
    padding: 12px;
    display: flex;
    align-items: center;
    background-color: #FFFFFF;
    border-radius: 10px;
    font-size: 20px;
    font-weight: 600;
    flex-basis: 32%;
    -webkit-user-select: none;
            user-select: none;
    cursor: pointer;
}

.main_select_section__hBRld img {
    padding: 0 20px;
}

.main_select_selectedSection__VTXKd {
    background-color: #B4C3E4;
    color: #FFFFFF;
}

.main_select_kpduPortsContainer__E\\+QdH {
    width: calc(100% - var(--sidebar-margin) - 40px);
    margin-left: calc(var(--sidebar-margin) + 20px);
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}

.main_select_kpduPorts__TDLoM {
    display: flex;
    justify-content: center;
    flex-direction: column;
    position: relative;
    min-height: 137px;
}

.main_select_port__f9WHA {
    background-color: #3BA810;
    border-radius: 50%;
    width: 28px;
    height: 28px;
    position: absolute;
}

.main_select_ign__E-NAq {
    background-color: #D53C3C;
    width: 29px;
    height: 29px;
    position: absolute;
    border-radius: 50%;
    font-family: "Lexend Variable", sans-serif;
    font-size: 12px;
    color: #FFFFFF;
    display: flex;
    justify-content: center;
    align-items: center;
}

.main_select_emergencyStop__iBRdl {
    border-radius: 50%;
    width: 20px;
    height: 20px;
    background-color: #E72D39;
    margin-left: 20px;
}`, "",{"version":3,"sources":["webpack://./src/screens/detail/components/main_select/main_select.module.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,aAAa;IACb,yBAAyB;IACzB,aAAa;IACb,mBAAmB;IACnB,+BAA+B;IAC/B,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,aAAa;IACb,mBAAmB;IACnB,yBAAyB;IACzB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,yBAAiB;YAAjB,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,gDAAgD;IAChD,+CAA+C;IAC/C,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,sBAAsB;IACtB,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;IACzB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,0CAA0C;IAC1C,eAAe;IACf,cAAc;IACd,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,iBAAiB;AACrB","sourcesContent":[".container {\n    width: 100%;\n    display: flex;\n    background-color: #ECF0F8;\n    padding: 29px;\n    border-radius: 15px;\n    font-family: Mulish, sans-serif;\n    justify-content: space-between;\n    margin-bottom: 20px;\n}\n\n.section {\n    padding: 12px;\n    display: flex;\n    align-items: center;\n    background-color: #FFFFFF;\n    border-radius: 10px;\n    font-size: 20px;\n    font-weight: 600;\n    flex-basis: 32%;\n    user-select: none;\n    cursor: pointer;\n}\n\n.section img {\n    padding: 0 20px;\n}\n\n.selectedSection {\n    background-color: #B4C3E4;\n    color: #FFFFFF;\n}\n\n.kpduPortsContainer {\n    width: calc(100% - var(--sidebar-margin) - 40px);\n    margin-left: calc(var(--sidebar-margin) + 20px);\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n}\n\n.kpduPorts {\n    display: flex;\n    justify-content: center;\n    flex-direction: column;\n    position: relative;\n    min-height: 137px;\n}\n\n.port {\n    background-color: #3BA810;\n    border-radius: 50%;\n    width: 28px;\n    height: 28px;\n    position: absolute;\n}\n\n.ign {\n    background-color: #D53C3C;\n    width: 29px;\n    height: 29px;\n    position: absolute;\n    border-radius: 50%;\n    font-family: \"Lexend Variable\", sans-serif;\n    font-size: 12px;\n    color: #FFFFFF;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n.emergencyStop {\n    border-radius: 50%;\n    width: 20px;\n    height: 20px;\n    background-color: #E72D39;\n    margin-left: 20px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `main_select_container__-KtmE`,
	"section": `main_select_section__hBRld`,
	"selectedSection": `main_select_selectedSection__VTXKd`,
	"kpduPortsContainer": `main_select_kpduPortsContainer__E+QdH`,
	"kpduPorts": `main_select_kpduPorts__TDLoM`,
	"port": `main_select_port__f9WHA`,
	"ign": `main_select_ign__E-NAq`,
	"emergencyStop": `main_select_emergencyStop__iBRdl`
};
export default ___CSS_LOADER_EXPORT___;
